import React from 'react'
import { GaugeDiv } from './styles'

interface IGaugeProps {
    color: string
    total: number
    actual: number
}

export const HorizontalGauge: React.FC<IGaugeProps> = ({ actual, color, total }) => {
    return (
        <GaugeDiv>
            <div
                className="progress"
                style={{
                    background: color || 'green',
                    width: `${(actual / total) * 100}%`
                }}
            />
        </GaugeDiv>
    )
}
